import React, { useContext as useContextCore } from 'react'
import type { UseListWithSelection, UseNotification } from '@ztechapps/common.hook'
import { useListWithSelection } from '@ztechapps/common.hook'
import { useNotification } from '@ztechapps/common.hook'
import type { Notification } from '@ztechapps/common.contract'

export type NotificationListProviderProps = {
  children: React.ReactNode
  filterCategory: string
}

export type NotificationListContext = { notificationListWithSelection: UseListWithSelection<Notification> } & UseNotification &
  Omit<NotificationListProviderProps, 'children'>

const context = React.createContext<NotificationListContext>({} as NotificationListContext)
const CoreProvider = context.Provider

export const NotificationListProvider = ({ children, filterCategory, ...props }: NotificationListProviderProps) => {
  const useNotificationResult = useNotification({ listProps: { listActionOptions: { storageKey: filterCategory } } })
  const notificationListWithSelection = useListWithSelection<Notification>(useNotificationResult?.notifications?.list)
  return <CoreProvider value={{ notificationListWithSelection, filterCategory, ...useNotificationResult, ...props }}>{children}</CoreProvider>
}

export const useNotificationListContext = () => useContextCore(context)
